var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 13.5,
    viewBox: "0 0 19.5 13.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4429",
    "data-name": "Group 4429",
    transform: "translate(-287.25 -27.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8804",
    "data-name": "Path 8804",
    d: "M-17065.8-21752.639h15",
    transform: "translate(17356.805 21792.639)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8803",
    "data-name": "Path 8803",
    d: "M-17065.8-21752.639h15",
    transform: "translate(17356.805 21786.639)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4356",
    "data-name": "Group 4356",
    transform: "translate(288 28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8802",
    "data-name": "Path 8802",
    d: "M-17065.8-21752.639h15",
    transform: "translate(17068.805 21752.639)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4355",
    "data-name": "Group 4355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8830",
    "data-name": "Path 8830",
    d: "M-17065.8-21752.639h.375",
    transform: "translate(17065.805 21764.639)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8829",
    "data-name": "Path 8829",
    d: "M-17065.8-21752.639h.375",
    transform: "translate(17065.805 21758.639)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8828",
    "data-name": "Path 8828",
    d: "M-17065.8-21752.639h.375",
    transform: "translate(17065.805 21752.639)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.749668e8b71be2f98a4d77cf45f58731.svg";
export { ForwardRef as ReactComponent };